var $ = require('./../sw-jquery/sw-jquery');
var _ = require('underscore');
var log = require('./log');
var decode = require('./decode');
var bindActionCreators = require('js/lib/actions/utils/bindActionCreators');

var Backbone = require('./sw-backbone');
Backbone.$ = $;

var sw = _.extend(window.sw || {}, window.SW || {}, {});
window.sw = window.SW = sw;

sw = _.defaults(sw, {
  startTime:  new Date().getTime(),
  utf8Decode: decode.utf8_decode,
  base64Decode: decode.base64_decode,
  log: log,
  data: {}
});


var POLLING_STATUS = {
  success: 'success',
  crash:   'crash'
};

sw.setSetting = function (setting, value, userId = 0) {
  var data =  {
    setting: setting,
    value: value,
    userId: userId
  };

  $.ajax({
    type:'POST',
    url:'/api/set-setting',
    data: data
  });
};


sw.getSetting = function (setting, callback) {
  var data =  {
    setting: setting
  };

  $.ajax({
    type:'GET',
    url:'/api/get-setting',
    data: data,
    success: function(response) {
      callback(response);
    }
  });
};


sw.requestIdleCallback = require('./sw-requestIdleCallback');

sw.utils = require('./sw-utils');

// Turn window.sw into a global event bus
_.extend(sw, Backbone.Events);

require('./request-animation-pollyfill');
sw.polling = function(endpoint, callback, interval, data) {

  interval = interval || 10000; // default to 10 seconds
  data = data || null;
  var elapsed = 0;
  
  var then,
      now;
  
  then = now = Date.now();

  var pollFunc;
  pollFunc = function() {
    now = Date.now();

    elapsed = now - then;

    if (elapsed > interval) {
      $.ajax({
        url: endpoint,
        data: data,
        xhrFields: {
          withCredentials: true
        },
        success: function(response) {
          if (response.result === POLLING_STATUS.success) {
            callback(response.data);
          } else if (response.result === POLLING_STATUS.crash) {
            window.console.log('The model processing job has crashed.');
          } else {
            window.requestAnimationFrame(pollFunc);
          }
        },
        dataType: 'json'
      });

      then = now;
    } else {
      window.requestAnimationFrame(pollFunc);
    }
  };

  pollFunc();

};


// This is the event that is used specifically for the dispatcher pattern
// on the shapeways event Bus
var SW_ACTION_EVENT = 'SW_ACTION_EVENT';

_.extend(sw, {
  
  // Make that action availbile to anyone who has requires sw
  SW_ACTION_EVENT: SW_ACTION_EVENT,

  /**
   * Convenience method which binds action creators to the sw dispatch method
   * @param  {any}    actionCreators    typically an object any functions found will be bound
   * @return {any}                      matches the form of whatever was passed in via actionCreators argument
   */
  bindActionCreators: function bindActionCreatorsPartial(actionCreators) {
    return bindActionCreators(actionCreators, sw.dispatch.bind(sw));
  },

  /**
   * Triggers the special event used by sw event bus
   * @param  {object} action an action object to be dispatched
   */
  dispatch: function dispatch(action) {
    sw.trigger(SW_ACTION_EVENT, action);
  }

});

module.exports = sw;
